import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { FirebaseFunctionsService } from 'src/app/services/firebase-functions.service';

@Component({
  selector: 'app-s-inscrire',
  templateUrl: './s-inscrire.component.html',
  styleUrls: ['./s-inscrire.component.scss']
})
export class SInscrireComponent implements OnInit {

  courriel:string = '';
  password:string = '';
  confirmPassword: string = '';
  username:string = '';
  schoolId: string = '';
  prenom:string = '';
  nom:string = '';
  type:string = '';
  cdc:string = '';
  province: string = '';
  regionId: string = '';
  regions: any[] = [];
  ecolesAray:any[];
  isCdcFormUsed: boolean = false;
  filteredList1: any[];
  
  constructor(private afs: FirebaseFunctionsService, public app:AppComponent) {}

  ngOnInit(): void {
    setTimeout(this.app.afficherPage,2000);
  }
  go(url){
    this.app.navigateTo(url);
  }
  emailValidation(): boolean{
    const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-\.]+\.[a-zA-Z0-9-]{2,}$/;
    if(this.courriel.match(mailformat)){return true;}else{return false;}
  }
  passwordValidation(): boolean{
    const pwdformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{6,}$/;
    if(this.password.match(pwdformat) && this.confirmPassword.match(pwdformat)){
      return (this.password == this.confirmPassword) ? true: false;
    }
    return false;
  }
  cdcValidation(){
    const cdcRegex = /^cdc[a-zA-Z0-9]{11}$/;
    if(this.cdc.match(cdcRegex)){return true;}else{return false}
  }
  AllFormValidation(){
    const nomRegex = /^[a-zA-Z \-]{2,20}$/;
    const prenomRegex = /^[a-zA-Z \-]{2,20}$/;
    this.nom = this.nom.trim();
    this.prenom = this.prenom.trim();
    if(!this.nom.match(nomRegex)){
      this.app.showMessage(3,' ne doit contenir que des characteres alphabetique',3000);
      return false;
    }else if(!this.prenom.match(prenomRegex)){
      this.app.showMessage(3,' ne doit contenir que des characteres alphabetique',3000);
      return false;
    }else{return true;}
  }
  onProvinceChosen(){
    this.regionId = '';
    this.schoolId = '';
    this.getRegions();
  }
  getRegions(){
    this.afs.getRegionByProvince(this.province).forEach( res => {
      this.regions = res;
    });
  }
  onRegionChosen(){
    this.schoolId = '';
    this.getEcoles();
  }
  getEcoles(){
    this.afs.getEcolesByRegion(this.regionId).forEach( res => {
      this.ecolesAray = res;
    });
  }
  signUp(){
    const isEmailValide = this.emailValidation();
    const isPasswordValide = this.passwordValidation();
    if(isEmailValide && isPasswordValide){
      if(this.AllFormValidation() && this.schoolId != '' && this.type !=''){
        this.username = this.username.charAt(0).toUpperCase() + this.username.slice(1);
        this.nom = this.nom.charAt(0).toUpperCase() + this.nom.slice(1).toLowerCase();
        this.prenom = this.prenom.charAt(0).toUpperCase() + this.prenom.slice(1).toLowerCase();
        this.afs.createUtilisateur(this.courriel,this.password,this.username,this.schoolId,this.nom,this.prenom,this.type,[]).then( res => {
          if(typeof res === 'string'){
            this.app.showMessage(1, 'Utilisateur ' + this.username + ' enregistré.', 3000);
          }
        })
      }else{
        if( this.schoolId == '' && this.type != ''){
          this.afs.showMessage(3, 'Veuillez choisir une ecole.', 3000);
        }else if(this.schoolId == '' && this.type == ''){
          this.afs.showMessage(3,'Veuillez sélectionner une école et un type d\'utilisateur', 3000);
        }
        else if(!this.AllFormValidation()){
          this.afs.showMessage(3, 'Veuillez entrer votre nom et prénom.', 3000);
        }else{
          this.afs.showMessage(3, 'Veuillez sélectionner un type d\'utilisateur.', 3000);
        }
      }
    }else{
      if(!isEmailValide && isPasswordValide){
        this.afs.showMessage(3, 'Veuillez entrer un courriel valide.', 3000);
      }
      else if(!isEmailValide && !isPasswordValide){
        this.afs.showMessage(3, 'Veuillez entrer un courriel et mot de passe valide.', 3000);
      }else{
        if(this.password != this.confirmPassword){
          this.afs.showMessage(3, 'La confirmation de votre mot de passe ne correspond pas.', 3000);
        }else{
          this.afs.showMessage(3, 'Veuillez entrer un mot de passe valide.', 3000);
        }
        
      }
    }
  }
  signUpByCdc(){
    if(this.cdcValidation() && this.AllFormValidation()){
      this.username = this.username.charAt(0).toUpperCase() + this.username.slice(1);
      this.nom = this.nom.charAt(0).toUpperCase() + this.nom.slice(1).toLowerCase();
      this.prenom = this.prenom.charAt(0).toUpperCase() + this.prenom.slice(1).toLowerCase();
      this.afs.createUtilisateurByCdc(this.courriel,this.password,this.username,this.cdc,this.nom,this.prenom);
    }else{
      this.app.showMessage(3,'Le code de classe n\'est pas correcte.',3000);
    }
  }
  usingCdcForm(){
    this.isCdcFormUsed = (this.isCdcFormUsed == true)? false:true;
    const pCdc = document.querySelector('.p_cdc') as HTMLElement;
    if(this.isCdcFormUsed){
      pCdc.innerHTML = 'Utiliser le formulaire';
    }else{
      pCdc.innerHTML = 'Utiliser le code de classe';
    }
  }
}
